export class ErrorObject extends Error {
	constructor(public responseJson: any, public configName?: string, public sourceApplication: string = '') {
		super();
		Object.setPrototypeOf(this, ErrorObject.prototype);
	}
}
